import { LoggerFactory } from '@cvent/logging/LoggerFactory';
import { isNotificationChannel, DELETE_MESSAGE_ACTION_TYPE } from './utils';

const LOG = LoggerFactory.create('messageActionHandler');

/**
 * Method is used to handle message action event of pubNub
 */
export const messageActionHandler = ({ message, deleteNotifications }) => {
  const {
    channel: channelName,
    data: { value: notificationId, type }
  } = message;
  if (isNotificationChannel(channelName) && type === DELETE_MESSAGE_ACTION_TYPE)
    deleteNotifications([notificationId]);
  else {
    const errorMessage = `No message action event handler found for channel ${channelName} or type ${type} is incorrect`;
    LOG.error(errorMessage, {
      message
    });
    throw new Error(errorMessage);
  }
};
